// extracted by mini-css-extract-plugin
module.exports = {"Banner":"admin-portal__GPFaxNumbers__Banner","BannerButton":"admin-portal__GPFaxNumbers__BannerButton"};